<ion-list lines="none">
  <ion-item *ngFor="let rating of ratings">
    <ion-avatar slot="start">
      <ion-img src="../../../../assets/images/icon-hammer.svg" alt="Verified Trade Index (VTI)"></ion-img>
    </ion-avatar>
    <ion-label>{{ rating.productInstallationType.type }}</ion-label>
    <ion-badge color="gc-yellow" slot="end">{{ rating.value }}</ion-badge>
  </ion-item>
</ion-list>
